import Vue from 'vue';
import { PaymentMethod, PaymentMethodType } from '../constants';

export class SharedPaymentsService {    
    constructor(private vue: Vue) { }

    private isAllowedWithRetention(paymentMethodType: PaymentMethod) : boolean {
        switch (paymentMethodType.type) {
            case PaymentMethodType.Redsys:
            case PaymentMethodType.Stripe:
            case PaymentMethodType.BridgerPay:
                return true;
            default: 
                return false;
        }
    }

    private isAllowedWithoutRetention(paymentMethod: PaymentMethod, hasSavedCard: boolean) : boolean {
        return this.isToken(paymentMethod) || paymentMethod.allowTokenization;
    }

    public filterAllowedPaymentMethods(paymentMethods: PaymentMethod[], withRetention: boolean) : any[] {
        const hasSavedCard = this.hasSavedCard(paymentMethods);
        
        return withRetention
            ? paymentMethods.filter((p) => this.isAllowedWithRetention(p))
            : paymentMethods.filter((p) => this.isAllowedWithoutRetention(p, hasSavedCard));
    }

    public allowVouchers(paymentMethods: any[], withRetention: boolean) : { allowed: boolean, reason: string | null} {
        if(withRetention) {
            return { 
                allowed: false,  
                reason: this.vue.$t("Sorry, it's not yet possible to pay shared bookings with a voucher, we are working on it") + '.'
            };
        }
        // If there is a saved card, vouchers are allowed
        if(this.hasSavedCard(paymentMethods) === true) {
            return { allowed: true, reason: null };
        }
        return { 
            allowed: false,  
            reason: 
                this.vue.$t("Sorry, but it's not possible to pay for this booking with your voucher") 
                + '.' +
                this.vue.$t("We need your card as a guarantee for any amount your teammates may not cover, so just this once, your share of the booking will be charged to it")
                + '.'
        };
    }

    private hasSavedCard(paymentMethods: PaymentMethod[]) : boolean {
        return paymentMethods.some(this.isToken);
    }

    private isToken(paymentMethod: PaymentMethod) : boolean {
        return Number.isInteger(paymentMethod.tokenId);
    }
}